module.exports = __webpack_public_path__ + "static/background-intro-a64d6e0c995255fd537f326d3ea60429.jpg";